<template>
  <div>
    <div class="row">
      <div id="pane-left" class="col-md-6 pane py-3">

        <div v-if="order" class="card border-0 shadow-sm mb-3" id="order-summary">
          <div class="card-body">

            <div class="row large font-weight-bold">
              <div class="col-4 text-right">Order</div>
              <div class="col-8">{{ order_id }}</div>
            </div>
            <div class="row">
              <div class="col-4 text-right">Source / Channel</div>
              <div class="col-8"><i :class="order.source.icon"></i>
                {{ order.source.name }}
                <span v-if="order.channel">/ {{ order.channel.name }}</span>
              </div>
            </div>
            <div v-if="order.user" class="row">
              <div class="col-4 text-right">Added By</div>
              <div class="col-8">
                {{ order.user.name }}
                <span class="small text-muted">{{ order.user.email }}</span>
              </div>
            </div>
            <div class="row large" style="margin-top:15px">
              <div class="col-4 text-right">Name</div>
              <div class="col-8">{{ order.name }}</div>
            </div>
            <div class="row">
              <div v-if="order.telephone" class="col-4 text-right">Telephone</div>
              <div class="col-8">{{ order.telephone }}</div>
            </div>
            <div v-if="order.email" class="row">
              <div class="col-4 text-right">E-mail</div>
              <div class="col-8">{{ order.email }}</div>
            </div>
            <div v-if="order.address_1" class="row">
              <div class="col-4 text-right">Address</div>
              <div class="col-8">
                {{ order.address_1 }}
                <template v-if="order.address_2">
                  &middot; {{ order.address_2 }}
                </template>
              </div>
            </div>
            <div v-if="order.city" class="row">
              <div class="col-4 text-right">City</div>
              <div class="col-8">{{ order.city }}</div>
            </div>
            <div v-if="order_expiry" class="row large" style="margin-top:15px">
              <div class="col-4 text-right">Remaining</div>
              <div class="col-8">
                <vue-countdown :time="order_expiry" @end="handleCountdownEnd">
                  <template slot-scope="props">
                    <span :class="props.totalSeconds < 300 ? 'text-danger' : 'text-muted'">
                      {{ props.minutes }}:{{ props.seconds > 9 ? props.seconds : '0' + props.seconds }}
                    </span>
                  </template>
                </vue-countdown>
              </div>
            </div>
            <div class="row">
              <div class="col-4 text-right text-uppercase">Note</div>
              <div class="col-8">Stocks are temporarily reserved for this order. Payment must be made before the timer runs out or the order will be cancelled automatically.</div>
            </div>

          </div>
        </div>

        <div v-if="order" class="card border-0 shadow-sm mb-3 table-responsive">
          <order-products :order="order"></order-products>
        </div>

      </div>
      <div id="pane-right" class="col-md-6 pane py-3">

        <form v-if="order">

          <div v-if="order.credit_notes && order.credit_notes.length" class="card border-0 shadow-sm mb-3">
            <div class="card-body pb-0">

              <div v-for="(creditNote, k) in order.credit_notes" :key="k">
                <div class="form-group row mb-0">
                  <label :for="'input-credit-note-code-' + creditNote.id" class="col-sm-3 col-form-label col-form-label-lg">Credit Note</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control-plaintext form-control-lg" :id="'input-credit-note-code-' + creditNote.id" :value="creditNote.code" readonly>
                  </div>
                </div>
                <div class="form-group row">
                  <label :for="'input-credit-note-amount-' + creditNote.id" class="col-sm-3 col-form-label col-form-label-lg">Amount</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control-plaintext form-control-lg" :id="'input-credit-note-amount-' + creditNote.id" :value="creditNote.amount | numberToRs" readonly>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div v-if="order.gift_vouchers && order.gift_vouchers.length" class="card border-0 shadow-sm mb-3">
            <div class="card-body pb-0">

              <div v-for="(giftVoucher, k) in order.gift_vouchers" :key="k">
                <div class="form-group row mb-0">
                  <label :for="'input-gift-voucher-code-' + giftVoucher.id" class="col-sm-3 col-form-label col-form-label-lg">Gift Voucher</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control-plaintext form-control-lg" :id="'input-gift-voucher-code-' + giftVoucher.id" :value="giftVoucher.code" readonly>
                  </div>
                </div>
                <div class="form-group row">
                  <label :for="'input-gift-voucher-amount-' + giftVoucher.id" class="col-sm-3 col-form-label col-form-label-lg">Amount</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control-plaintext form-control-lg" :id="'input-gift-voucher-amount-' + giftVoucher.id" :value="giftVoucher.amount | numberToRs" readonly>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div v-if="order.due && order.payment_method" class="card border-0 shadow-sm">
            <div class="card-body">

              <template v-if="order.payment_method.source==='website'">
                <div class="alert alert-info">You have selected a <strong>Website</strong> payment method for the Point of Sale order. Therefore click the "Complete Order" button below to complete the order through the customer facing billing portal.</div>
              </template>

              <div class="form-group row">
                <label for="input-payment-method" class="col-sm-3 col-form-label col-form-label-lg">Payment Method</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control-plaintext form-control-lg" id="input-payment-method" :value="order.payment_method ? order.payment_method.name : null" readonly>
                </div>
              </div>

              <template v-if="order.payment_method.source === 'point_of_sale'">
                <template v-if="order.payment_method.settings.payment_status === 'paid'">
                  <div class="form-group row">
                    <label for="input-identifier" class="col-sm-3 col-form-label">Card # / Identifier</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" name="identifier" id="input-identifier" v-model="payment.identifier" placeholder="(optional)" maxlength="50">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="input-transaction-id" class="col-sm-3 col-form-label">Transaction ID</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" name="transaction_id" id="input-transaction-id" v-model="payment.transaction_id" placeholder="(optional)" maxlength="50">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="input-amount" class="col-sm-3 col-form-label col-form-label-lg">Amount</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control-plaintext form-control-lg" id="input-amount" :value="order.due | numberToRs" readonly>
                    </div>
                  </div>
                  <div v-if="order.payment_method && (order.payment_method.name).match(/cash/i)" class="form-group row">
                    <div class="col-sm-9 offset-sm-3">
                      <button type="button" class="btn btn-lg btn-outline-primary" @click.prevent="triggerCashCalculation(order.due)">
                        <i class="fas fa-calculator mr-1"></i> Accept Cash
                      </button>
                    </div>
                  </div>
                  <div class="form-group row mb-0">
                    <div class="col-sm-9 offset-sm-3">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="check-payment-received" name="payment_received" value="1" v-model="payment.payment_received" required>
                        <label class="custom-control-label" for="check-payment-received">Payment has been received</label>
                      </div>
                    </div>
                  </div>
                </template>
                <div v-else class="alert alert-info mb-0">Order will be marked as <strong>{{ order.payment_method.settings.order_status }}</strong> and the payment status will be set to <strong>{{ order.payment_method.settings.payment_status }}</strong>.</div>
              </template>

            </div>
          </div>

        </form>

      </div>
    </div>

    <div style="height:80px"></div>

    <div v-if="order" id="payment-footer" class="row">
      <div class="col-6 left">
        <button type="button" :class="'btn btn-lg ' + (disable_cancel ? 'btn-outline-danger' : 'btn-danger')" @click="cancelOrder" :disabled="disable_cancel || processing_cancel">
          <i class="fas fa-circle-notch fa-spin" v-if="processing_cancel"></i>
          <i class="fas fa-angle-left" v-if="!processing_cancel"></i>
          Cancel & Modify
        </button>
      </div>
      <div class="col-6 text-right">
        <template v-if="order.due && order.payment_method && order.payment_method.source==='website'">
          <button type="button" class="btn btn-lg btn-primary mr-2" @click.prevent="promptWebsiteOrderLink">
            <i class="fas fa-link"></i>
            Get Payment Link
          </button>
          <button type="button" class="btn btn-lg btn-primary" @click.prevent="processWebsiteOrder">
            <i class="fas fa-external-link-alt"></i>
            Complete Order
          </button>
        </template>
        <button v-if="!order.due || !order.payment_method || order.payment_method.source==='point_of_sale'" type="submit" :class="'btn btn-lg ' + (order.due && order.payment_method && order.payment_method.settings.payment_status === 'paid' && !payment.payment_received ? 'btn-outline-success' : 'btn-success')" @click.prevent="confirmOrder" :disabled="(order.due && order.payment_method && order.payment_method.settings.payment_status === 'paid' && !payment.payment_received) || processing_confirm">
          <i class="fas fa-circle-notch fa-spin" v-if="processing_confirm"></i>
          Confirm Order
        </button>
      </div>
    </div>

    <div class="modal fade" id="modal-website-payment-link" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Payment Link</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <textarea class="form-control" rows="4" v-model="billing_portal_url" readonly></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal-calculate-cash-balance" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-calculator mr-1"></i> Accept Cash</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label col-form-label-lg">Amount</label>
              <div class="col-sm-9">
                <input type="text" :value="cash_calculation_amount | numberToRs" class="form-control-lg form-control-plaintext" readonly="readonly">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label col-form-label-lg">Tendered</label>
              <div class="col-sm-9">
                <input type="number" v-model="cash_calculation_tendered" class="form-control form-control-lg input-cash-calculation-tendered" @click="focusCashCalculationTenderInput">
                <button v-for="(denomination, k) in cash_calculation_denominations" :key="k" @click.prevent="addCashCalculationDenomination(denomination)" type="button" :class="'btn btn-lg btn-' + (!cash_calculation_denomination_usage[denomination] ? 'outline-' : '') + 'primary mt-2 mr-2'">
                  {{ denomination | numberToRs(0) }}
                  <span v-if="cash_calculation_denomination_usage[denomination]" class="badge badge-light">{{ cash_calculation_denomination_usage[denomination] }}</span>
                </button>
                <button type="button" class="btn btn-lg btn-outline-secondary mt-2" @click.prevent="resetCashCalculation">Reset</button>
              </div>
            </div>
            <div v-if="cash_calculation_balance > 0" class="form-group row mb-0">
              <label class="col-sm-3 col-form-label col-form-label-lg">Due</label>
              <div class="col-sm-9">
                <input type="text" :value="cash_calculation_balance | numberToRs" class="form-control-lg form-control-plaintext" readonly="readonly">
                <p class="mb-0 text-danger"><i class="fas fa-info-circle mr-1"></i> Charge this amount from the customer</p>
              </div>
            </div>
            <div v-if="cash_calculation_balance <= 0" class="form-group row mb-0">
              <label class="col-sm-3 col-form-label col-form-label-lg">Balance</label>
              <div class="col-sm-9">
                <input type="text" :value="Math.abs(cash_calculation_balance) | numberToRs" class="form-control-lg form-control-plaintext" readonly="readonly">
                <p class="mb-0 text-success"><i class="fas fa-info-circle mr-1"></i> Return this amount to the customer</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" :class="'btn btn-lg btn-' + (cash_calculation_balance > 0 ? 'outline-' : '') + 'primary'" data-dismiss="modal" :disabled="cash_calculation_balance > 0" @click.prevent="confirmCashCalculation">Cash Received</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import jQuery from 'jquery'
import VueCountdown from '@chenfengyuan/vue-countdown'
import OrderProducts from './partials/Products'

export default {
  name: 'OrderPayment',
  props: ['order_id'],
  components: {
    OrderProducts,
    VueCountdown
  },
  data () {
    return {
      fetching: false,
      processing_cancel: false,
      payment_received: false,
      processing_confirm: false,
      disable_cancel: false,

      order: null,
      order_expiry: null,
      billing_portal_url: null,

      payment: {
        transaction_id: null,
        identifier: null,
        payment_received: 0
      },

      cash_calculation_payment: null,
      cash_calculation_amount: 0,
      cash_calculation_tendered: 0,
      cash_calculation_denominations: [5000, 1000, 500, 100, 50, 20, 10, 5, 2, 1],
      cash_calculation_denomination_usage: {}
    }
  },
  mounted () {
    this.fetchOrder()
  },
  computed: {
    cash_calculation_balance: function () {
      return this.cash_calculation_amount - parseFloat(this.cash_calculation_tendered)
    },
    cashCalculationDenominationUsage: {
      get: function (denomination) {
        return this.cash_calculation_denomination_usage[denomination] ? this.cash_calculation_denomination_usage[denomination] : false
      },
      set: function (denomination) {
        if (!this.cash_calculation_denomination_usage[denomination]) {
          this.cash_calculation_denomination_usage[denomination] = 1
        } else {
          this.cash_calculation_denomination_usage[denomination]++
        }
      }
    }
  },
  methods: {
    fetchOrder () {
      this.fetching = true

      axios.get('/orders/' + this.order_id).then((response) => {
        let order = response.data.data

        if (order.order_status.code) {
          // If the same order is available as the pending order, remove it.
          if (localStorage.getItem('pending-order-id') === this.order_id) {
            // this.cancelOrder()
            localStorage.removeItem('pending-order-id')
          }

          if (order.order_status.code === 'approved') {
            this.$router.push({name: 'order.view', params: {order_id: this.order_id}})
            return false
          } else if (order.order_status.code === 'cancelled') {
            this.$router.push({name: 'sale'})
            return false
          }

          this.$toast.error('This order has an invalid status: ' + order.order_status.name)

          return false
        }

        this.order = order

        let orderExpiry = new Date(order.date).getTime() + (1000 * 60 * 15)
        let now = new Date().getTime()
        let remainingTime = orderExpiry > now
        this.order_expiry = remainingTime > 0 ? (orderExpiry - now) : 1

        if (order.payment_method && order.payment_method.source === 'website' && typeof order.payment_link !== 'undefined') {
          this.billing_portal_url = order.payment_link
        }
      }).catch(error => {
        this.$toast.error('Failed to fetch the order. ' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.fetching = false
      })
    },

    cancelOrder () {
      if (this.disable_cancel) {
        return false
      }

      this.processing_cancel = true

      axios.patch(process.env.URLS_POS_API + '/orders/' + this.order._id + '/cancel', {
        ignore_if_paid: true
      }).then((response) => {
        localStorage.removeItem('pending-order-id')
        this.$router.push({name: 'sale'})
      }).catch(error => {
        this.processing_cancel = false

        let errorMessage = 'Failed to cancel the order.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)
      })
    },

    handleCountdownEnd () {
      this.cancelOrder()
    },

    confirmOrder () {
      this.processing_confirm = true

      const postData = {
        ...this.payment,
        ...{ mark_as_delivered: localStorage.getItem('mark-items-as-delivered') === 'true' }
      }

      axios.post(process.env.URLS_POS_API + '/orders/' + this.order._id + '/confirm', postData).then((response) => {
        localStorage.removeItem('cart-id')
        localStorage.removeItem('pending-order-id')
        this.$router.push({name: 'order.view', params: {order_id: this.order_id}})
      }).catch(error => {
        this.processing_confirm = false

        let errorMessage = 'Failed to confirm the order.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)
      })
    },

    promptWebsiteOrderLink () {
      localStorage.removeItem('cart-id')
      localStorage.removeItem('pending-order-id')
      this.disable_cancel = true
      jQuery('#modal-website-payment-link').modal('show').on('shown.bs.modal', function () {
        jQuery(this).find('textarea').select()
      })
    },

    processWebsiteOrder () {
      localStorage.removeItem('cart-id')
      localStorage.removeItem('pending-order-id')
      this.disable_cancel = true
      document.location.href = this.billing_portal_url
    },

    triggerCashCalculation (total) {
      this.cash_calculation_amount = total
      this.resetCashCalculation()
      jQuery('#modal-calculate-cash-balance').modal('show').on('shown.bs.modal', () => {
        this.focusCashCalculationTenderInput()
      })
    },

    addCashCalculationDenomination (denomination) {
      let data = this.cash_calculation_denomination_usage

      if (!data[denomination]) {
        data[denomination] = 1
      } else {
        data[denomination]++
      }

      this.cash_calculation_tendered = parseFloat(this.cash_calculation_tendered) + denomination
      this.cash_calculation_denomination_usage = null
      this.cash_calculation_denomination_usage = data
    },

    resetCashCalculation () {
      this.cash_calculation_tendered = 0
      this.cash_calculation_denomination_usage = {}
    },

    focusCashCalculationTenderInput () {
      jQuery('#modal-calculate-cash-balance .input-cash-calculation-tendered').select()
    },
    confirmCashCalculation () {
      this.payment.payment_received = true
      jQuery('#modal-calculate-cash-balance').modal('hide')
    }
  }
}
</script>

<style scoped>
  #order-summary {
    font-size: 14px;
  }
  #order-summary .large {
    font-size: 24px;
  }
  #order-summary .row:not(:last-child) {
    margin-bottom: 3px;
  }
  #payment-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #e9ecef;
    padding: 15px 20px;
    box-shadow: 0 -1rem 3rem rgba(0,0,0,.175);
  }

  @media (min-width: 768px) {
    .pane {
      position: fixed;
      top: 52px;
      height: calc(100vh - 52px - 73px);
    }
    #pane-left {
      left: 0;
    }
    #pane-right {
      right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/order/Payment.vue